// src/i18n.js
import Vue from "vue";
import VueI18n from "vue-i18n";
import messages from "./locales";

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: "ko", // 기본 언어 설정
  messages, // 번역 메시지
});

export default i18n;
